import { render, staticRenderFns } from "./FeedGrid.vue?vue&type=template&id=761af0d6&scoped=true&"
import script from "./FeedGrid.vue?vue&type=script&lang=ts&"
export * from "./FeedGrid.vue?vue&type=script&lang=ts&"
import style0 from "./FeedGrid.vue?vue&type=style&index=0&id=761af0d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761af0d6",
  null
  
)

export default component.exports